import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BackOfficeRole } from "../enum/shared/backoffice-role.enum";
import { PolicyModel } from "../model/shared/policy.model";
import { FirestoreService } from "./api/auth/firestore.service";

@Injectable({
    providedIn: "root"
})

export class PolicyService {
    constructor(
        private readonly firestoreService: FirestoreService
    ) { }

    getUserPolicies(collectionName: string): Observable<Array<PolicyModel>> {
        return this.firestoreService.getDocument(collectionName)
            .pipe(
                map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as PolicyModel;
                    const id = a.payload.doc.id;

                    return { id, ...data };
                }))
            );
    }

    getUserPolicy(collectionName: string, objectKey: string, objectValue: any): Observable<Array<PolicyModel>> {
        return this.firestoreService.getDocumentWithCondition(collectionName, objectKey, objectValue)
            .pipe(
                map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as PolicyModel;
                    const id = a.payload.doc.id;

                    return { id, ...data };
                }))
            );
    }

    onCheckCanEditUserRole(loggedInUserRole: number, currentUserRole: number): boolean {
        // Superuser
        if (loggedInUserRole === BackOfficeRole.SuperUser) {
            return true;
        } else if (loggedInUserRole === BackOfficeRole.Administrator) {
            // Administrator
            if (currentUserRole !== BackOfficeRole.SuperUser && currentUserRole !== BackOfficeRole.Administrator) {
                return true;
            }
        } else {
            // Moderator
            return false;
        }
    }
}
